module.exports = __webpack_public_path__ + "static/media/irelia-black.abd92452.svg";